import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';

import {
  SectionContentContainer,
  Tab,
  Tabs,
  SectionHeading,
} from '../../common/components/styledComponents';

import { UploadDicomTab } from './UploadDicomTab';
import { UploadImageTab } from './UploadImageTab';

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  padding-top: 55px;

  ${p =>
    p.theme.isMobile &&
    `
    /* box-sizing 없는 건 의도 */
    padding: 24px 28px;
    background: white;
    `}
`;

export const UploadImages = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.uploadImages',
  });

  const [tab, setTab] = useState(0);

  return (
    <>
      <SectionContentContainer>
        <SectionHeading>{t('heading')}</SectionHeading>
        <Tabs $marginTop="28px">
          <Tab $width="277px" onClick={() => setTab(0)} $selected={tab === 0}>
            {t('tabs.0')}
          </Tab>
          <Tab $width="277px" onClick={() => setTab(1)} $selected={tab === 1}>
            {t('tabs.1')}
          </Tab>
        </Tabs>
        <ContentWrapper>
          {tab === 1 ? <UploadImageTab /> : <UploadDicomTab />}
        </ContentWrapper>
      </SectionContentContainer>
    </>
  );
};
